/**
 * Ant Design token overrides for the HOTmaths homepage, layered on vector's base theme.
 *
 * Vector's `ConfigProvider` merges whatever is passed here over its own `BASE_THEME`, with the caller
 * winning, so this only names what differs.
 *
 * Almost everything is already handled by re-pointing the `--color-primary-*` custom properties in
 * `styles/hotmathsBrand.css` — vector's component tokens are `var()` references to that scale, so they
 * follow automatically. The one value that cannot work that way is `colorPrimary`: Ant Design derives its
 * hover and active shades from it algorithmically, which needs a real colour rather than a `var()`. So it
 * is repeated here as a literal, and the two must be kept in step.
 */
import {hotmathsColors} from './styles/hotmathsColors';

export const HOME_ANTD_THEME = {
    token: {
        // Must equal --color-primary-600. AntD computes its own shades from this.
        colorPrimary: hotmathsColors.primary600,
        colorLink: hotmathsColors.primary800,

        /*
         * Ant Design's defaults are translucent blacks and cool greys that fail on the warm surfaces:
         * help text at rgba(0,0,0,.45) is under 4.5:1 on both, and #D9D9D9 input edges are well under the
         * 3:1 a control boundary needs (WCAG 1.4.11). These are vector's warm neutrals instead - the same
         * scale the rest of the page uses.
         */
        colorText: 'var(--color-text-primary)',
        colorTextHeading: 'var(--color-text-primary)',
        colorTextLabel: 'var(--color-text-primary)',
        colorTextSecondary: 'var(--color-text-secondary)',
        colorTextTertiary: 'var(--color-text-tertiary)',
        colorTextDescription: 'var(--color-text-tertiary)',
        colorBorder: 'var(--color-neutral-550)',
        // Literal because AntD derives the error shades from it; vector's --color-feedback-incorrect.
        colorError: '#98473E',
    },
    components: {
        /*
         * The Schools/At-home pricing toggle. The default white-on-light-grey selection is about 1.1:1 -
         * the chosen option was all but invisible. This fills the chosen option in brand orange, the rest
         * as plain text on the dark pricing card's own darker track.
         */
        Segmented: {
            trackBg: 'var(--color-neutral-800)',
            itemColor: 'var(--color-neutral-200)',
            itemHoverColor: '#FFFFFF',
            itemHoverBg: 'var(--color-neutral-700)',
            itemSelectedBg: '#F58220',
            itemSelectedColor: '#26211C',
        },
    },
};

export default HOME_ANTD_THEME;
